import { useState } from 'react';

const useModal = (state = false) => {
    const [isShowing, setIsShowing] = useState(state);

    function toggle(val) {
        setIsShowing(typeof val === 'boolean' ? !val : !isShowing);
    }
    return { isShowing, toggle };
};

export default useModal;
